// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"94b50762","471":"848b4d3d","488":"c68e87e5","884":"b796dd4a"}[chunkId] + ".chunk.js";
};